<ng-container>
  <ion-content #content>
    @if (orderTableItems.length > 0) {
      <ion-toolbar #tableToolBar>
        <ion-buttons slot="end">
          <ion-button class="cancel-btn" fill="solid" (click)="close()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title class="cart-title">{{ 'Nav.TableOrder' | translate }}</ion-title>
      </ion-toolbar>
    }
    @if (orderTableItems.length > 0) {
      <ion-content #tableContent class="bg-lightgrey">
        <ion-grid #tableGrid class="top-division">
          @for (item of orderTableItems; track item; let i = $index) {
            <ion-row>
              <ion-col size="8">
                <ion-row class="item-name-row">
                  <div class="truncate-text">
                    <span>{{item.quantity}}x &nbsp;</span>
                    <span>{{getItemName(item)}}&nbsp;</span>
                    @if (item.itemDetailCombination) {
                      <ion-icon name="bag-check-outline"></ion-icon>
                    }
                  </div>
                </ion-row>
                @if (item.itemDetailCombination) {
                  <ion-row class="option-name">
                    <ion-col>
                      @if (item.itemDetailCombination.size) {
                        {{item.itemDetailCombination.size.translations[translationService.getLanguage()]}}
                      }
                      @if (item.itemDetailCombination.size && item.itemDetailCombination.color) {
                        +
                      }
                      @if (item.itemDetailCombination.color) {
                        {{item.itemDetailCombination.color.translations[translationService.getLanguage()]}}
                      }
                    </ion-col>
                  </ion-row>
                }
                @for (option of item.options; track option; let oi = $index) {
                  <ion-row >
                    <!-- Hide if quantity of option is null -->
                    @if (option.quantity != 0) {
                      <ion-col class="option-name">
                        <div class="truncate-text">
                          {{option.quantity}}x &nbsp;{{getOptionName(option.name)}}
                        </div>
                        @if (option.itemDetailCombination) {
                          ({{option.itemDetailCombination.size.translations[translationService.getLanguage()]}}+{{option.itemDetailCombination.color.translations[translationService.getLanguage()]}})
                        }
                      </ion-col>
                    }
                  </ion-row>
                }
                @if (item.allergies != '') {
                  <ion-row class="allergies">{{'SpecialRequest.Allergies' | translate }}:
                  {{ item.allergies }}</ion-row>
                }
                @if (item.note != '') {
                  <ion-row class="specialRequest">
                    {{'SpecialRequest.SpecialRequest' | translate }}:
                    {{ item.note }}
                  </ion-row>
                }
              </ion-col>
              <ion-col size="3" style="text-align: right;">
                @if (!item._hidePrice) {
                  <span class="item-name-row">{{ item.price * item.quantity | currency }}</span>
                }
                @if (item._hidePrice) {
                  <span>&nbsp;</span>
                }
                <div [ngStyle]="item.itemDetailCombination && {'margin-top': '22.5px'}"></div>
                @for (option of item.options; track option) {
                  <ion-row>
                    <!-- Hide if quantity of option is null -->
                    @if (option.quantity != 0 && !option.itemDetailCombination) {
                      <ion-col class="option-price">+{{option.price * option.quantity * item.quantity | currency}}</ion-col>
                    }
                    @if (option.quantity != 0 && option.itemDetailCombination) {
                      <ion-col class="option-price">+{{option.itemDetailCombination.price * option.quantity | currency}}</ion-col>
                    }
                  </ion-row>
                }
              </ion-col>
            </ion-row>
          }
        </ion-grid>
        <div #tableDiv class="bottom-division" style="position: absolute; width: 100%;">
          <store-checkout-total [store]="store" [preOrder]="order" [options]="totalOptions" [orderType]="'table'" ></store-checkout-total>
        </div>
      </ion-content>
    }
  </ion-content>
</ng-container>